import React from "react"
import PropTypes from "prop-types"
import DearDesignerFavicon from "../../../images/favicon.png"
import ctl from "@netlify/classnames-template-literals"

const AuthorInfo = ({ image, name }) => {
  const imageStyle = ctl(
    `rounded-full md:w-9 w-6 md:h-9 h-6 ${
      name === "DearDesigner" && "border border-white"
    }`
  )

  return (
    <div className="flex items-center text-[0px]">
      <span className="block">
        <img
          src={name !== "DearDesigner" ? image : DearDesignerFavicon}
          className={imageStyle}
          alt={name}
        />
      </span>
      <p className="block md:text-p14 text-p12 leading-none mt-0 ml-3 font-normal">
        {name}
      </p>
    </div>
  )
}

AuthorInfo.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.any,
}

export default AuthorInfo
